function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { createPolizaComment } from "./actions/PolizaCommentActions";
import { createPolizaFile } from "./actions/PolizaFileActions";
import { getVersionsQueryKey } from "./actions/BitacoraVersionActions";
import CommentFileForm from "./CommentFileForm";

var CommentsFilesSection = function CommentsFilesSection(props) {
  var polizaId = props.polizaId,
      token = props.token,
      fileTypes = props.fileTypes;
  var queryClient = useQueryClient();

  var refreshAll = function refreshAll() {
    // Solo refrescar el historial de versiones, que es donde se mostrarán los comentarios y archivos
    queryClient.invalidateQueries({
      queryKey: getVersionsQueryKey(polizaId)
    });
  };

  var handleSubmit = function handleSubmit(data) {
    var promises = []; // Crear comentario si existe

    if (data.comment && data.comment.content && data.comment.content.trim()) {
      promises.push(createPolizaComment({
        poliza_id: polizaId,
        content: data.comment.content,
        management_type: data.comment.management_type,
        contact_method: data.comment.contact_method,
        next_step: data.comment.next_step,
        status: data.comment.status
      }, token));
    } // Crear archivo si existe


    if (data.file && data.file.file && data.file.file_type) {
      promises.push(createPolizaFile({
        poliza_id: polizaId,
        file: data.file.file,
        file_type: data.file.file_type
      }, token));
    }

    if (promises.length === 0) {
      alert("Por favor, ingrese un comentario o seleccione un archivo");
      return;
    }

    Promise.all(promises).then(function () {
      refreshAll();
    })["catch"](function (error) {
      console.error("Error saving:", error);
      var errorMessage = "Error al guardar. Por favor, intenta de nuevo.";

      if (error.response) {
        // El servidor respondió con un código de error
        if (error.response.status === 422) {
          // Error de validación
          var errors = error.response.data;

          if (typeof errors === 'object') {
            var errorList = Object.entries(errors).map(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  value = _ref2[1];

              return "".concat(key, ": ").concat(Array.isArray(value) ? value.join(', ') : value);
            }).join('\n');
            errorMessage = "Error de validaci\xF3n:\n".concat(errorList);
          } else {
            errorMessage = errors || errorMessage;
          }
        } else if (error.response.status === 401 || error.response.status === 403) {
          errorMessage = "No tiene permisos para realizar esta acción.";
        } else if (error.response.data) {
          errorMessage = error.response.data.error || error.response.data.message || errorMessage;
        }
      } else if (error.request) {
        // La petición se hizo pero no hubo respuesta
        errorMessage = "No se pudo conectar con el servidor. Por favor, verifica tu conexión.";
      }

      alert(errorMessage);
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "comments-files-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      marginBottom: "0",
      backgroundColor: "#fff",
      border: "1px solid #dee2e6",
      boxShadow: "none"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header",
    style: {
      padding: "10px 15px",
      backgroundColor: "#fff",
      borderBottom: "1px solid #dee2e6"
    }
  }, /*#__PURE__*/React.createElement("h5", {
    style: {
      margin: "0",
      fontSize: "16px",
      fontWeight: "600"
    }
  }, "Comentarios y Archivos")), /*#__PURE__*/React.createElement("div", {
    className: "card-body",
    style: {
      padding: "0",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React.createElement(CommentFileForm, {
    onSubmit: handleSubmit,
    fileTypes: fileTypes
  }))));
};

export default CommentsFilesSection;